module.exports = __webpack_public_path__ + "img/appchat_datatable_empty_state.b719bf0.svg";